module.exports = __webpack_public_path__ + "img/PL08804.a0316bc3.png";